import { combineReducers } from "redux";

import {
	workspaceKeysSlice,
	workspaceMeshKeyRotationsSlice,
	workspaceSettingsSlice,
} from "./index";
import { queuedRadioChannelTogglesSlice } from "./radio/workspace.radio.queuedToggles.slice";
import { workspacesSlice } from "./workspaces.slice";

export const workspaceReducerMap = {
	workspaces: workspacesSlice.reducer,
	workspaceSettings: workspaceSettingsSlice.reducer,
	workspaceKeys: workspaceKeysSlice.reducer,
	workspaceMeshKeyRotations: workspaceMeshKeyRotationsSlice.reducer,
	queuedRadioChannelToggles: queuedRadioChannelTogglesSlice.reducer,
};

const reducers = combineReducers(workspaceReducerMap);

export type WorkspaceState = ReturnType<typeof reducers>;
